import Vue from 'vue';
import Vuex from 'vuex';
import hitch from './hitch';
import plate from './plate';

Vue.use(Vuex);

const store = new Vuex.Store( {
	modules: {
		hitch,
		plate
	}
});

export default store;